import React from 'react';
import { Box, Container, Toolbar } from '@mui/material';
import Navbar from './Navbar';
import SubNavbar from './SubNavbar';
import { AnimatePresence } from 'framer-motion';
import { Outlet, useLocation } from 'react-router-dom';

// Routes that should use full width
const FULL_WIDTH_ROUTES = [
  '/team',
  '/communications'  // Add communications page to full width routes
];

const Layout = () => {
  const [activeSection, setActiveSection] = React.useState(null);
  const location = useLocation();
  const isFullWidth = FULL_WIDTH_ROUTES.includes(location.pathname);
  const isCommunicationsPage = location.pathname.startsWith('/communications');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar onSectionChange={setActiveSection} activeSection={activeSection} />
      <Toolbar /> {/* Empty toolbar to offset content below fixed AppBar */}
      <Box sx={{ 
        position: 'sticky', 
        top: 64, // Height of the AppBar
        zIndex: theme => theme.zIndex.appBar - 1,
        width: '100%',
        height: activeSection ? 'auto' : 0, // Set height to 0 when no active section
        overflow: 'hidden' // Hide overflow when collapsed
      }}>
        <AnimatePresence>
          {activeSection && (
            <SubNavbar section={activeSection} onClose={() => setActiveSection(null)} />
          )}
        </AnimatePresence>
      </Box>
      {isFullWidth ? (
        <Box 
          component="main" 
          sx={{ 
            flex: 1,
            width: '100%',
            p: 0,
            m: 0,
            // For communications page, position relative to viewport with dynamic top spacing
            ...(isCommunicationsPage && {
              position: 'absolute',
              top: activeSection ? 112 : 64, // 64px (navbar) + 48px (subnav) or just 64px
              bottom: 0,
              left: 0,
              right: 0
            })
          }}
        >
          <Outlet />
        </Box>
      ) : (
        <Container 
          component="main" 
          sx={{ 
            mt: 2,
            mb: 2, 
            flex: 1,
            transition: 'margin-top 0.3s ease'
          }}
        >
          <Outlet />
        </Container>
      )}
    </Box>
  );
};

export default Layout; 